const getConfigFromElement = el => {
    if (el.hasAttribute('data-discounts')) {
        const json = el.getAttribute('data-discounts')
        if (json !== '[]') {
            const config = JSON.parse(json)
            for (const amount in config) {
                config[amount] = parseFloat(config[amount])
            }
            return config
        }
    }
    return null
}

const parsePrice = str => {
    return parseFloat(str.replace('€', '').replace(',', '.').trim()).toFixed(2)
}

const printPrice = price => {
    return '€ ' + (price.toFixed(2)).replace('.', ',').replace(',00', ',-')
}

const initItem = ({ config, price, priceField, amountField, priceSumField }) => {
    const calculate = () => {
        const value = parseInt(amountField.value)
        let percent = 0
        for (const amount in config) {
            if (amount <= value) {
                percent = config[amount]
            }
        }
        const discount = (price * (percent / 100)).toFixed(2)
        priceField.innerHTML = printPrice(price - discount)

        if (priceSumField) {
            priceSumField.innerHTML = printPrice((price - discount) * value)
        }
    }

    if (!priceSumField) {
        amountField.addEventListener('change', calculate)
        amountField.addEventListener('keyup', calculate)
    }

    calculate()
}

const initDiscounts = () => {
    const basketForm = document.querySelector('form#add-to-basket')
    const quickAddButtons = document.querySelectorAll('div.quick-basket')
    // const basketTable = document.querySelector('#basket-table')

    const items = []
    if (basketForm) {
        const config = getConfigFromElement(basketForm)
        if (config) {
            const priceField = document.querySelector('.price')
            const price = parsePrice(priceField.innerHTML)
            const amountField = basketForm.querySelector('input#amount')
            items.push({
                config,
                price,
                priceField,
                amountField,
                priceSumField: null,
                priceSum: null,
            })
        }
    }

    for (const area of quickAddButtons) {
        const config = getConfigFromElement(area)
        if (config) {
            const priceField = area.querySelector('.price')
            const price = parsePrice(priceField.innerHTML)
            const amountField = area.querySelector('input[name="amount"]')
            items.push({
                config,
                price,
                priceField,
                amountField,
                priceSumField: null,
                priceSum: null,
            })
        }
    }

    // if (basketTable) {
    //     for (const row of basketTable.querySelectorAll('tr')) {
    //         const config = getConfigFromElement(row)
    //         if (config) {
    //             const priceField = row.querySelector('td.single-price')
    //             const price = parsePrice(priceField.innerHTML)
    //             const amountField = row.querySelector('.amount input[name="amount"]')
    //             const priceSumField = row.querySelector('td.price')
    //
    //             items.push({
    //                 config,
    //                 price,
    //                 priceField,
    //                 amountField,
    //                 priceSumField,
    //             })
    //         }
    //     }
    // }
    //
    // const callback = () => {
    //     if (basketTable) {
    //         const allSum = Array.from(basketTable.querySelectorAll('td.price')).reduce((res, col) => res + parseFloat(parsePrice(col.innerHTML)), 0)
    //         document.querySelector('#order-sum').innerHTML = printPrice(allSum)
    //     }
    // }

    items.map(item => initItem(item))
}

export default initDiscounts
